/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPaymentReceiptDetails} from '../api'

 export const useQueryGetPaymentReceiptDetails = createReactQueryHook('getPaymentReceiptDetails', getPaymentReceiptDetails)
